export default class Provider {
  id?: number
  company_name_ja?: string
  company_name_en?: string
  email?: string
  currency_id?: number
  zipcode?: string
  prefecture?: string
  city?: string
  street_address?: string
  building_info?: string
  telephone?: string
  representative?: string
  language_id?: number
  hp?: string
  description?: string
  admin_memo?: string
  bank_info_ja?: string
  bank_info_en?: string
  visibility_status?: string
  book_size?: number
  language?: string
  selling_book_regulation_size?: number
  sold_book_regulation_size?: number
  pdf_url?: string
  pdf_name?: string
  is_monopoly?: boolean
  party_id?: number

  constructor(data?: Partial<Provider>) {
    Object.assign(this, data);
  }

  static get RANSACK_SELF_SEARCH_ATTRIBUTE() {
    return "id"
  }

  static get RANSACK_SELF_QUERY_KEY() {
    return "company_profile_name_native_or_company_profile_name_cont_any"
  }

  static get RANSACK_BOOK_QUERY_KEY() {
    return "provider_id_in"
  }

  static get VISIBILITY_STATUSES() {
    return [
      { value: "open_access", i18nKey: "models/provider:visibilityStatuses.open_access" },
      { value: "limited", i18nKey: "models/provider:visibilityStatuses.limited" },
      { value: "hidden", i18nKey: "models/provider:visibilityStatuses.hidden" }
    ]
  }

  showName() {
    return this.company_name_ja
  }

  get showAllName() {
    return `${this.company_name_ja} (${this.company_name_en})`
  }

  showSubName() {
    return this.company_name_en
  }

  showOptionName() {
    return this.showAllName
  }

  get uid() {
    return `${this.id}_provider`
  }

  companyName(): string {
    return `${this.company_name_ja} (${this.company_name_en})`;
  }
}
